export const createPopupContent = (name: string, type: string, description: string, color: string, borderColor: string) => `
    <div style="
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
        padding: 10px;
        color: #2c3e50;
    ">
        <h3 style="
            margin: 0 0 8px 0;
            font-size: 18px;
            font-weight: 700;
            border-bottom: 2px solid ${color};
            padding-bottom: 4px;
        ">${name}</h3>
        <div style="margin-bottom: 10px;">
            <span style="
                background-color: ${color};
                color: white;
                padding: 2px 8px;
                border-radius: 4px;
                font-size: 11px;
                font-weight: 600;
                text-transform: uppercase;
                letter-spacing: 0.5px;
                border: 1px solid ${borderColor};
            ">${type}</span>
        </div>
        <p style="
            margin: 0;
            font-size: 14px;
            line-height: 1.5;
            color: #34495e;
        ">${description}</p>
    </div>
`;
